import React, { useMemo } from 'react';
import PatientProfileDataCompareTableRow from './PatientProfileDataCompareTableRow';
import { PatientCompareDataTableColumn } from '../../../Modules/Patient/Interfaces/Patient/PatientCompareDataTableColumn.interface';
import { PatientDataCompareKey } from '../../../Helpers/Patient/mapPatientDataToCompareTable.helper';

interface Props {
	columns: PatientCompareDataTableColumn[];
}

const PatientProfileDataCompareTableBody = ({ columns }: Props) => {
	const allKeys = useMemo(() => {
		const keys = new Set<PatientDataCompareKey>();
		columns.forEach(column => {
			Object.keys(column.data).forEach(key =>
				keys.add(key as PatientDataCompareKey),
			);
		});
		return Array.from(keys);
	}, [columns]);

	return (
		<tbody>
			{allKeys.map(key => (
				<PatientProfileDataCompareTableRow
					key={key}
					title={key}
					columns={columns}
				/>
			))}
		</tbody>
	);
};

export default PatientProfileDataCompareTableBody;
